import { render } from "./Info.vue?vue&type=template&id=2d563d72"
const script = {}
script.render = render

export default script